import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList } from '../../models/.catalog';
import rList from '../../models/rList';
import { rOyakKiraBilgileriUstBilgiYkgDetay } from '../../models/rOyakKiraBilgileriUstBilgiYkgDetay';

export default class OyakKiraBilgileriUstBilgiYkgDetayApi extends ApiBase<
  pList,
  rList<rOyakKiraBilgileriUstBilgiYkgDetay>
> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/OyakKiraBilgileriUstBilgiYkgDetay',
      }),
      options
    );
  }
}
